define('components/decorators/newspanel',[
    'jquery',
    'lib/select2',
    'lib/jquery-ui'
], function($) {

    $.extend(companyInfo.decorators, {
        'newspanel': function() {
          var panel = $(this);
          var items = panel.find(".newsitem");
          var addMore = panel.find(".newspanel__more");

          // CI-9989 Showing full text and adding show more/less button
          // $(items).each(function(){
          //   truncateItem(this);
          // });

          truncateByLetter(addMore,1);
          /**
           * the item title and text can only go over to lines.
           * more will result in "..."
           */
          function truncateItem(el){
            var elm = $(el);
            var title = elm.find(".newsitem__title a");
            var text = elm.find(".newsitem__text");


            truncateByWord(text, 2);
            truncateByWord(title, 2);


          }

          function truncateByLetter(el, maxLines){
            var elHeight = el.height();
            var lineHeight = getLineHeight(el);

            if(elHeight > lineHeight*maxLines){
              var text = el.text();
              var newText = text;

              //remove word for word and then check if the height is correct
              for(var i=0; i<text.length; i++){
                newText = newText.substr(0, newText.length-1);

                el.text(newText+'...');
                if(el.height() < getLineHeight(el)*maxLines){
                  break;
                }
              }
            }
          }

          function truncateByWord(el, maxLines){
            var elHeight = el.height();
            var lineHeight = getLineHeight(el);


            if(elHeight > lineHeight*maxLines){
              var text = el.text();
              var wordArray = text.split(" ");
              var newText = text;

              //remove word for word and then check if the height is correct
              for(var i=wordArray.length; i>0; i--){
                var word = wordArray[i-1];
                newText = newText.substr(0, newText.length-word.length-1);

                el.text(newText+'...');
                if(el.height() < getLineHeight(el)*maxLines){
                  break;
                }
              }
            }
          }

          /**
           * get the lineheight of the given element
           */
          function getLineHeight(el){
            var fontSize = el.css('font-size');
            if(fontSize){
              var lineHeight = Math.floor(parseInt(fontSize.replace('px','')) * 1.5);
              return lineHeight;
            }
          }
        }
    });

});

